import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

/* Layout */
import Layout from '../views/layout/layout'

Vue.use(Router)

export const constantRoutes = [{
    path: '/',
    name: 'auto',
    redirect: '/home',
    // component: () => import('@/views/home/home')
  },
  //  ***********************首页 strat**************
  {
    path: '/',
    component: Layout,
    name: 'home',
    meta: {
      title: '首页',
    },
    children: [{
        path: '/home',
        name: 'homePage',
        component: () => import('@/views/home/home'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/home/course_selecte',
        name: 'courseSelected',
        component: () => import('@/views/home/course_selecte'),

      },
    ]
  },

  // ***********************首页 end**************

  //  ***********************登录 strat**************
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    name: 'login',
    meta: {
      title: '登录',
    }
  },
  //  ***********************登录 strat**************


  //  ***********************课程相关 strat**************
  {
    path: '/course/try_topic',
    component: () => import('@/views/course/try_topic'),
    name: 'tryTopic',
    meta: {
      title: '小试牛刀',
    }
  },
  {
    path: '/course/course_work',
    component: () => import('@/views/course/course_work'),
    name: 'courseWork',
    meta: {
      title: '课程作业',
    }
  },
  {
    path: '/course/course_detail',
    component: () => import('@/views/course/course_detail'),
    name: 'courseDetail',
    meta: {
      title: '课程详情',
    }
  },
  {
    path: '/course/course_detail/course_scratch',
    component: () => import('@/views/course/course_scratch_container'),
    name: 'course_scratch',
    meta: {
      title: '课程scratch',
    }
  },
  {
    path: '/course/course_homework',
    component: () => import('@/views/course/course_homework'),
    name: 'course_homework',
    meta: {
      title: '课后任务',
    }
  },

  //  ***********************课程相关 end **************

  //  ***********************我的作品 start **************
  {
    path: '/my_production',
    component: () => import('@/views/home/my_production'),
    name: 'my_production',
    meta: {
      title: '我的作品',
    }
  },
  {
    path: '/my_production/scratch',
    component: () => import('@/views/course/single_scratch_container'),
    name: 'production_scratch',
    meta: {
      title: '编辑作品',
    }
  },
  //  ***********************我的作品 end **************

  //  ***********************我的错题 start **************
  {
    path: '/my_wrongbook',
    component: () => import('@/views/course/my_wrongbook'),
    name: 'my_wrongbook',
    meta: {
      title: '我的错题',
    }
  },
  //  ***********************我的错题 end **************
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),

  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
};

export default router



// WEBPACK FOOTER //
// ./src/router/index.js